import * as ents from '@attain-apps/entities'

/**
 * Browser selection retained for the Agent-specific and Shared document
 * workspaces.
 */
export interface Selection {
  /** Workspace whose document query is currently active. */
  readonly mode: Selection.Mode
  /** Agent-specific selection retained while browsing Shared documents. */
  readonly agent: Selection.Agent
  /** Shared target selection retained while browsing Agent documents. */
  readonly shared: Selection.Shared
}

export namespace Selection {
  /** Knowledge-base document workspace shown in the Admin page. */
  export enum Mode {
    Shared = 'shared',
    Agent = 'agent',
  }

  /** Identifies the selected private agent source without copying its model. */
  export interface Agent {
    readonly agentId?: ents.core.agent.Agent.Id
    readonly dataSource?: ents.core.agent.KnowledgeBase.Management.DataSource.Target
  }

  /** Identifies the selected Tenant or Zone audience in the shared source. */
  export interface Shared {
    readonly targetType?:
      | ents.core.agent.KnowledgeBase.Target.Type.Tenant
      | ents.core.agent.KnowledgeBase.Target.Type.Zone
    readonly tenantId?: ents.core.admin.Tenant.Id
    readonly zoneId?: ents.core.admin.Zone.Id
  }

  /** Initial browser selection before management inventory is available. */
  export const INITIAL: Selection = {
    agent: {},
    mode: Mode.Shared,
    shared: {},
  }

  /**
   * Builds the exact shared knowledge-base audience once its required IDs have
   * been selected.
   */
  export function getSharedTarget(
    selection: Shared,
  ):
    | ents.core.agent.KnowledgeBase.Target.Tenant
    | ents.core.agent.KnowledgeBase.Target.Zone
    | undefined {
    if (
      selection.targetType ===
        ents.core.agent.KnowledgeBase.Target.Type.Tenant &&
      selection.tenantId
    ) {
      return {
        tenantId: selection.tenantId,
        type: ents.core.agent.KnowledgeBase.Target.Type.Tenant,
      }
    }
    if (
      selection.targetType === ents.core.agent.KnowledgeBase.Target.Type.Zone &&
      selection.tenantId &&
      selection.zoneId
    ) {
      return {
        tenantId: selection.tenantId,
        type: ents.core.agent.KnowledgeBase.Target.Type.Zone,
        zoneId: selection.zoneId,
      }
    }
    return undefined
  }
}
